import React from 'react'
import { reduxForm } from 'redux-form'
import RequestTourHandler from 'components/shared/modals/handlers/request-tour'
import PropTypes from 'prop-types'
import BuildingInquireFields from './fields'

const BuildingInquireForm = ({
  handleSubmit,
  submitButtonTitle,
  className,
  form,
  handleClick,
  city,
}) => {
  return (
    <form onSubmit={handleSubmit} className={className}>
      <BuildingInquireFields form={form} />
      <p className="mb-4 text-sm text-secondary-greypricetype text-left">Contact us for a free consultation (no agent fees payable by tenants) </p>
      <RequestTourHandler
        city={city}
        submitButtonTitle={submitButtonTitle}
        handleClick={handleClick}
        isBuildingRequest={true}
      />
    </form>
  )
}

BuildingInquireForm.propTypes = {
  className: PropTypes.string,
  handleSubmit: PropTypes.func,
  submitButtonTitle: PropTypes.string,
  form: PropTypes.string,
  handleClick: PropTypes.func,
  initialValues: PropTypes.object,
  city: PropTypes.string,
}

export default reduxForm({})(BuildingInquireForm)
